import { PlusIcon } from '@heroicons/react/24/outline';
import * as Sentry from '@sentry/react';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import googleAdsIcon from '../assets/images/googleAdsIcon.png';
import { UserContext } from '../contexts/UserContext';
import ConnectAdsAccountsModal from '../modals/ConnectAdsAccountsModal';
import { track } from '../utils/analytics';
import { getGoogleUrl } from '../utils/auth';
import Button from './Common/Button';

const scopes = ['https://www.googleapis.com/auth/adwords'];

export default function ConnectGoogleAds() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { createOAuthRequest } = useContext(UserContext);

  const [connectAccountsModalOpen, setConnectAccountsModalOpen] =
    useState<string>();

  useEffect(() => {
    const googleAdsRequestId = searchParams.get('googleAdsRequestId');
    if (!googleAdsRequestId) return;

    setConnectAccountsModalOpen(googleAdsRequestId);
  }, [searchParams]);

  const handleClick = useCallback(async () => {
    track('connect_google_ads_button_click');

    try {
      const from = location.pathname;
      const state = await createOAuthRequest('google', from, scopes);

      window.location.replace(getGoogleUrl(from, state, scopes));
    } catch (e) {
      Sentry.captureException(e);
      console.error(e);
    }
  }, [createOAuthRequest, location.pathname]);

  return (
    <>
      <ConnectAdsAccountsModal
        provider="google"
        requestId={connectAccountsModalOpen || ''}
        open={!!connectAccountsModalOpen}
        onClose={() => {
          setSearchParams(new URLSearchParams());
          setConnectAccountsModalOpen(undefined);
        }}
      />
      <div className="flex max-w-xs flex-col items-center text-center">
        <img src={googleAdsIcon} width={62} />
        <h3 className="mt-2 text-sm font-semibold text-gray-900">
          Connect your Google Ads account
        </h3>
        <p className="mt-2 text-sm text-gray-500">
          By connecting your ad account we can fully integrate your ads with
          amazing dynamic landing pages
        </p>
        <div className="mt-6">
          <Button size="large" onClick={handleClick}>
            <PlusIcon className="h-5 w-5" aria-hidden="true" />
            Connect
          </Button>
        </div>
      </div>
    </>
  );
}
